module.exports = "/_next/static/images/54dde91e9191b7ed90ac97f04f702fd0-mastercard-lg.jpg";